import { create } from 'zustand';
import { supabase } from '@ad3d/supabase';
import { User } from '@supabase/supabase-js';

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  loading: boolean;
  initialize: () => Promise<void>;
  login: () => void; // Kept for compatibility but effectively unused with Supabase auth flow
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  user: null,
  loading: true,
  initialize: async () => {
    // 1. Get initial session
    const { data: { session } } = await supabase.auth.getSession();
    set({ 
      isAuthenticated: !!session, 
      user: session?.user ?? null,
      loading: false 
    });

    // 2. Listen for changes (sign in, sign out, etc.)
    supabase.auth.onAuthStateChange((_event, session) => {
      set({ 
        isAuthenticated: !!session, 
        user: session?.user ?? null,
        loading: false 
      });
    });
  },
  login: () => {}, // No-op, handled by Supabase auth flow
  logout: async () => {
    await supabase.auth.signOut();
    set({ isAuthenticated: false, user: null });
  },
}));
